export const skills = [
  {
    title: "HTML/CSS",
    level: 90,
  },
  {
    title: "JavaScript",
    level: 85,
  },
  {
    title: "TypeScript",
    level: 75,
  },
  {
    title: "ReactJS",
    level: 80,
  },
  {
    title: "NextJS",
    level: 70,
  },
  {
    title: "ExpressJS",
    level: 80,
  },
  {
    title: "NodeJS",
    level: 65,
  },
  {
    title: "MongoDB",
    level: 70,
  },
  {
    title: "Docker",
    level: 60,
  },
  {
    title: "Jenkins",
    level: 50,
  },
  {
    title: "Git & Github",
    level: 80,
  },
  {
    title: "Shell Scripting & Linux",
    level: 60,
  },
  {
    title: "Communication",
    level: 75,
  },
  {
    title: "Teamwork",
    level: 75,
  },
];
